import styled from "styled-components";

export const Wrapper = styled.div`
  clear:left;
  font:14px Helvetica,Arial,sans-serif;
  width:100%;
`;

export const Input = styled.input`
  width: auto;
`;

export const Hidden = styled.div`
  position: absolute;
  left: -5000px;
`;

export const Clear = styled.div`
  
`;